import React from "react";


const Loader = ({ label = "جارٍ التحميل...", minHeight = 458 }) => (
    <div
        style={{
            minHeight,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 12,
        }}
    >
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            xmlns="http://www.w3.org/2000/svg"
            stroke="currentColor"
            style={{ opacity: 0.9 }}
        >
            <g fill="none" fillRule="evenodd" strokeWidth="4">
                <circle cx="22" cy="22" r="20" strokeOpacity=".2" />
                <path d="M42 22c0-11.046-8.954-20-20-20">
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 22 22"
                        to="360 22 22"
                        dur="0.8s"
                        repeatCount="indefinite"
                    />
                </path>
            </g>
        </svg>
        <div style={{ fontSize: 14, opacity: 0.8 }}>{label}</div>
    </div>
);


export default Loader;